const TouchKitRouter = () => {
    const router = new VueRouter({
        routes: [
            {
                path: "/",
                name: "scene",
                redirect: app.defaultRoute
             
            },
            { path: "/scene/*", component: PageScene }
        ]
    });

    router.afterEach((to, from) => {
        touchKit.TrackingManager.onRouteChanged(to, from);
        if (config.DYNAMIC_PAGE_TITLE) {
            var pageTitle = touchKit.PageManager.pageTitle(to.path);
            var title = app.data.metadata.title;
            if (pageTitle) {
                title += " - " + pageTitle;
            }
            document.title = title;
        }
    })
    
    return router;
}